// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.employerSelectionComponent {
  width: 408px;
  margin-left: 14px;
  display: flex;
  flex-direction: column;
}
.employerSelectionComponent .selectionButton {
  padding: 8px 12px;
  gap: 12px;
  background: #ffffff;
  border: 1px solid #075453;
  border-radius: 8px;
  width: 114px;
  padding-top: 10px;
  padding-bottom: 2px;
  display: flex;
  justify-content: space-between;
}
.employerSelectionComponent .dropDownWrapper {
  position: relative;
  top: 1px;
}
.employerSelectionComponent .dropDownWrapper .dropDown {
  width: 408px;
  position: absolute;
  background-color: rgb(255, 255, 255);
  z-index: 100;
  box-shadow: 6px 6px 18px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  padding: 8px;
}
.employerSelectionComponent .dropDownWrapper .dropDown .searchBox {
  background: #fafafa;
  border: 1px solid #e9e9e9;
  border-radius: 8px;
  width: 100%;
  height: 40px;
  padding: 8px 12px;
  display: flex;
  flex-direction: row;
  align-content: space-between;
}
.employerSelectionComponent .dropDownWrapper .dropDown .searchBox input {
  width: 92%;
  border: none;
  background: #fafafa;
  font-size: 16px;
}
.employerSelectionComponent .dropDownWrapper .dropDown .searchBox input:focus {
  outline: none;
}
.employerSelectionComponent .dropDownWrapper .dropDown .textRow {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 14px;
  margin-bottom: 12px;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  color: #c1c1c1;
}
.employerSelectionComponent .dropDownWrapper .dropDown .textRow .right {
  text-decoration-line: underline;
  color: #868686;
}

.employerSelectionComponentRow {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  height: 42px;
}
.employerSelectionComponentRow .left {
  display: flex;
}
.employerSelectionComponentRow .left .image {
  height: 32px;
  width: 32px;
  background-color: #c1c1c1;
  border-radius: 16px;
  color: white;
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 18px;
  align-items: center;
  color: #ffffff;
  text-align: center;
  padding-top: 7px;
}
.employerSelectionComponentRow .left .name {
  position: relative;
  top: 7px;
  margin-left: 5px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  color: #505054;
}
.employerSelectionComponentRow .right img {
  height: 12px;
  position: relative;
  top: 5px;
  right: 8px;
}`, "",{"version":3,"sources":["webpack://./src/screens/calendarNote/employerSelection/employerSelection.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;AACJ;AACI;EACI,iBAAA;EACA,SAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,8BAAA;AACR;AAEI;EACI,kBAAA;EACA,QAAA;AAAR;AACQ;EACI,YAAA;EAEA,kBAAA;EACA,oCAAA;EACA,YAAA;EACA,2CAAA;EACA,kBAAA;EACA,YAAA;AAAZ;AACY;EACI,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,4BAAA;AAChB;AAAgB;EACI,UAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;AAEpB;AAAgB;EACI,aAAA;AAEpB;AACY;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAChB;AAAgB;EACI,+BAAA;EACA,cAAA;AAEpB;;AAIA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;AADJ;AAGI;EACI,aAAA;AADR;AAEQ;EACI,YAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AAAZ;AAGQ;EACI,kBAAA;EACA,QAAA;EACA,gBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AADZ;AAKQ;EACI,YAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;AAHZ","sourcesContent":[".employerSelectionComponent {\n    width: 408px;\n    margin-left: 14px;\n    display: flex;\n    flex-direction: column;\n\n    .selectionButton {\n        padding: 8px 12px;\n        gap: 12px;\n        background: #ffffff;\n        border: 1px solid #075453;\n        border-radius: 8px;\n        width: 114px;\n        padding-top: 10px;\n        padding-bottom: 2px;\n        display: flex;\n        justify-content: space-between;\n    }\n\n    .dropDownWrapper {\n        position: relative;\n        top: 1px;\n        .dropDown {\n            width: 408px;\n            // height: 322px;\n            position: absolute;\n            background-color: rgb(255, 255, 255);\n            z-index: 100;\n            box-shadow: 6px 6px 18px rgba(0, 0, 0, 0.1);\n            border-radius: 8px;\n            padding: 8px;\n            .searchBox {\n                background: #fafafa;\n                border: 1px solid #e9e9e9;\n                border-radius: 8px;\n                width: 100%;\n                height: 40px;\n                padding: 8px 12px;\n                display: flex;\n                flex-direction: row;\n                align-content: space-between;\n                input {\n                    width: 92%;\n                    border: none;\n                    background: #fafafa;\n                    font-size: 16px;\n                }\n                input:focus {\n                    outline: none;\n                }\n            }\n            .textRow {\n                display: flex;\n                flex-direction: row;\n                justify-content: space-between;\n                margin-top: 14px;\n                margin-bottom: 12px;\n                font-weight: 500;\n                font-size: 12px;\n                line-height: 18px;\n                color: #c1c1c1;\n                .right {\n                    text-decoration-line: underline;\n                    color: #868686;\n                }\n            }\n        }\n    }\n}\n.employerSelectionComponentRow {\n    display: flex;\n    justify-content: space-between;\n    flex-direction: row;\n    height: 42px;\n\n    .left {\n        display: flex;\n        .image {\n            height: 32px;\n            width: 32px;\n            background-color: #c1c1c1;\n            border-radius: 16px;\n            color: white;\n            font-style: normal;\n            font-weight: 700;\n            font-size: 12px;\n            line-height: 18px;\n            align-items: center;\n            color: #ffffff;\n            text-align: center;\n            padding-top: 7px;\n        }\n\n        .name {\n            position: relative;\n            top: 7px;\n            margin-left: 5px;\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 500;\n            font-size: 16px;\n            color: #505054;\n        }\n    }\n    .right {\n        img {\n            height: 12px;\n            position: relative;\n            top: 5px;\n            right: 8px;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
